import BadgeIcon from '@mui/icons-material/Badge'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import ChairIcon from '@mui/icons-material/Chair'
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded'
import HandshakeIcon from '@mui/icons-material/Handshake'
import HomeWork from '@mui/icons-material/HomeWork'
import LinkIcon from '@mui/icons-material/Link'
import PeopleAlt from '@mui/icons-material/PeopleAlt'
import QueryStats from '@mui/icons-material/QueryStats'
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded'
import TuneRoundedIcon from '@mui/icons-material/TuneRounded'
import WorkspacesIcon from '@mui/icons-material/Workspaces'
import KeyRoundedIcon from '@mui/icons-material/KeyRounded'
import SchoolIcon from '@mui/icons-material/School'
import Diversity2Icon from '@mui/icons-material/Diversity2'
import ExtensionIcon from '@mui/icons-material/Extension'
import FingerprintIcon from '@mui/icons-material/Fingerprint'
import ChecklistIcon from '@mui/icons-material/Checklist'
import SummarizeIcon from '@mui/icons-material/Summarize'
import AgendaIcon from '@/components/ui/icons/Agenda'
import ConsultationsIcon from '@/components/ui/icons/Consultations'
import EmergencyPhysicianIcon from '@/components/ui/icons/EmergencyPhysician'
import ExpertisesIcon from '@/components/ui/icons/Expertises'
import HomeIcon from '@/components/ui/icons/Home'
import PatientsIcon from '@/components/ui/icons/Patients'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import BookIcon from '@mui/icons-material/Book'
import MessageIcon from '@mui/icons-material/Message'
import InterpreterModeIcon from '@mui/icons-material/InterpreterMode'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import GetAppIcon from '@mui/icons-material/GetApp'
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import GavelIcon from '@mui/icons-material/Gavel'
import TableChartIcon from '@mui/icons-material/TableChart'
import { SidebarItem, SidebarType } from '@/utils/subscription/types'

export const sidebarItemsMap: Record<SidebarType, SidebarItem | SidebarItem[]> = {
  [SidebarType.AdminApiKeys]: {
    name: SidebarType.AdminApiKeys,
    label: 'layouts.main.sidebar.apiKeys',
    link: '/admin/api-keys',
    icon: KeyRoundedIcon,
  },
  [SidebarType.AdminAirtable]: {
    name: SidebarType.AdminAirtable,
    label: 'Airtable',
    link: '/admin/airtable',
    icon: TableChartIcon,
  },
  [SidebarType.AdminGroups]: { name: SidebarType.AdminGroups, label: 'layouts.main.sidebar.groups', link: '/admin/groups', icon: GroupsRoundedIcon },
  [SidebarType.AdminLicenses]: {
    name: SidebarType.AdminLicenses,
    label: 'layouts.main.sidebar.licenses',
    link: '/admin/licenses',
    icon: BadgeIcon,
  },
  [SidebarType.AdminPlannings]: {
    name: SidebarType.AdminPlannings,
    label: 'layouts.main.sidebar.plannings',
    link: '/admin/plannings',
    icon: CalendarMonthIcon,
  },
  [SidebarType.AdminEstablishment]: {
    name: SidebarType.AdminEstablishment,
    label: 'layouts.main.sidebar.establishment',
    link: '/admin/establishment',
    icon: HomeWork,
  },
  [SidebarType.AdminPolicies]: {
    name: SidebarType.AdminPolicies,
    label: 'layouts.main.sidebar.policies',
    link: '/admin/policies',
    icon: ShieldRoundedIcon,
  },
  [SidebarType.AdminStaffs]: { name: SidebarType.AdminStaffs, label: 'layouts.main.sidebar.staffs', link: '/admin/staffs', icon: PeopleAlt },
  [SidebarType.AdminTrustedActors]: {
    name: SidebarType.AdminTrustedActors,
    label: 'layouts.main.sidebar.trustedActors',
    link: '/admin/trusted-actors',
    icon: HandshakeIcon,
  },
  [SidebarType.AdminInsWorklist]: {
    name: SidebarType.AdminInsWorklist,
    label: 'layouts.main.sidebar.insiManagement',
    link: '/admin/insi',
    icon: FingerprintIcon,
  },
  [SidebarType.AdminStatistics]: {
    name: SidebarType.AdminStatistics,
    label: 'layouts.main.sidebar.statistics',
    link: '/admin/statistics',
    icon: QueryStats,
  },
  [SidebarType.AdminPlugin]: {
    name: SidebarType.AdminPlugin,
    label: 'layouts.main.sidebar.plugin',
    link: '/admin/plugin',
    icon: ExtensionIcon,
  },
  [SidebarType.AdminKnowledgeBase]: {
    name: SidebarType.AdminKnowledgeBase,
    label: 'layouts.main.sidebar.knowledgeBase',
    link: '/admin/knowledge-base',
    icon: BookIcon,
  },
  [SidebarType.Calendar]: { name: SidebarType.Calendar, label: 'layouts.main.sidebar.calendar', link: '/agenda', icon: AgendaIcon },
  [SidebarType.Consultations]: {
    name: SidebarType.Consultations,
    label: 'layouts.main.sidebar.consultations',
    link: '/consultations',
    icon: ConsultationsIcon,
  },
  [SidebarType.Ethics]: {
    name: SidebarType.Ethics,
    label: 'layouts.main.sidebar.ethics',
    link: '/ethics',
    icon: GavelIcon,
  },
  [SidebarType.Emergency]: { name: SidebarType.Emergency, label: 'layouts.main.sidebar.emergency', link: '/emergency', icon: EmergencyPhysicianIcon },
  [SidebarType.EmergenciesMed]: {
    name: SidebarType.EmergenciesMed,
    label: 'layouts.main.sidebar.emergencies',
    link: '/emergencies',
    icon: WorkspacesIcon,
  },
  [SidebarType.Expertises]: [
    { name: SidebarType.Expertises, label: 'layouts.main.sidebar.expertises', link: '/expertises', icon: ExpertisesIcon },
    {
      name: 'expertiseMeetings',
      label: 'layouts.main.sidebar.expertiseMeetings',
      link: '/expertise-meetings',
      icon: InterpreterModeIcon,
    },
  ],
  [SidebarType.Home]: { name: SidebarType.Home, label: 'layouts.main.sidebar.home', link: '/', icon: HomeIcon, isPathBase: true },
  [SidebarType.LocalConsultations]: {
    name: SidebarType.LocalConsultations,
    label: 'layouts.main.sidebar.localConsultations',
    link: '/consultations/local',
    icon: ConsultationsIcon,
  },
  [SidebarType.MeetingLinks]: { name: SidebarType.MeetingLinks, label: 'layouts.main.sidebar.meetingLinks', link: '/meeting-links', icon: LinkIcon },
  [SidebarType.Networks]: { name: SidebarType.Networks, label: 'layouts.main.sidebar.networks', link: '/networks', icon: Diversity2Icon },
  [SidebarType.Onboarding]: { name: SidebarType.Onboarding, label: 'layouts.main.sidebar.onboarding', link: '/onboarding', icon: SchoolIcon },
  [SidebarType.Patients]: { name: SidebarType.Patients, label: 'layouts.main.sidebar.patients', link: '/patients', icon: PatientsIcon },
  [SidebarType.Staffs]: { name: SidebarType.Staffs, label: 'layouts.main.sidebar.staffs', link: '/staffs', icon: PeopleAlt },
  [SidebarType.SuperAdminApiKeys]: {
    name: SidebarType.SuperAdminApiKeys,
    label: 'layouts.main.sidebar.apiKeys',
    link: '/super-admin/api-keys',
    icon: KeyRoundedIcon,
  },
  [SidebarType.SuperAdminContracts]: {
    name: SidebarType.SuperAdminContracts,
    label: 'layouts.main.sidebar.contracts',
    link: '/super-admin/contracts',
    icon: HandshakeIcon,
  },
  [SidebarType.SuperAdminMeetingLinks]: {
    name: SidebarType.SuperAdminMeetingLinks,
    label: 'layouts.main.sidebar.meetingLinks',
    link: '/super-admin/meeting-links',
    icon: LinkIcon,
  },
  [SidebarType.SuperAdminStatistics]: {
    name: SidebarType.SuperAdminStatistics,
    label: 'layouts.main.sidebar.statistics',
    link: '/super-admin/statistics',
    icon: QueryStats,
  },
  [SidebarType.SuperAdminSettings]: {
    name: SidebarType.SuperAdminSettings,
    label: 'layouts.main.sidebar.settings',
    link: '/super-admin/settings',
    icon: TuneRoundedIcon,
  },
  [SidebarType.SuperAdminWaitingRooms]: {
    name: SidebarType.SuperAdminWaitingRooms,
    label: 'layouts.main.sidebar.waitingRooms',
    link: '/super-admin/waiting-rooms',
    icon: ChairIcon,
  },
  [SidebarType.SuperAdminHome]: {
    name: SidebarType.SuperAdminHome,
    label: 'layouts.main.sidebar.home',
    link: '/super-admin',
    icon: HomeIcon,
    isPathBase: true,
  },
  [SidebarType.SuperAdminLicenses]: {
    name: SidebarType.SuperAdminLicenses,
    label: 'layouts.main.sidebar.licenses',
    link: '/super-admin/licenses',
    icon: BadgeIcon,
  },
  [SidebarType.SuperAdminPolicies]: {
    name: SidebarType.SuperAdminPolicies,
    label: 'layouts.main.sidebar.policies',
    link: '/super-admin/policies',
    icon: ShieldRoundedIcon,
  },
  [SidebarType.SuperAdminMedicalActs]: {
    name: SidebarType.SuperAdminMedicalActs,
    label: 'layouts.main.sidebar.medicalActs',
    link: '/super-admin/medical-acts',
    icon: AccountBalanceIcon,
  },
  [SidebarType.WaitingRooms]: { name: SidebarType.WaitingRooms, label: 'layouts.main.sidebar.waitingRooms', link: '/waiting-rooms', icon: ChairIcon },
  [SidebarType.ShiftMarketplace]: {
    name: SidebarType.ShiftMarketplace,
    label: 'layouts.main.sidebar.shiftMarketplace',
    link: '/shift-marketplace',
    icon: ChairIcon,
  },
  [SidebarType.FormTemplates]: {
    name: SidebarType.FormTemplates,
    label: 'layouts.main.sidebar.formTemplates',
    link: '/forms-templates',
    icon: ChecklistIcon,
  },
  [SidebarType.Reports]: {
    name: SidebarType.Reports,
    label: 'layouts.main.sidebar.reports',
    link: '/reports',
    icon: SummarizeIcon,
  },
  [SidebarType.Chat]: {
    name: SidebarType.Chat,
    label: 'layouts.main.sidebar.chat',
    link: '/chat',
    icon: MessageIcon,
  },
  [SidebarType.MedConnectAgent]: {
    name: SidebarType.MedConnectAgent,
    label: 'layouts.main.sidebar.medConnectAgent',
    link: '/medconnect-agent',
    icon: SupportAgentIcon,
  },
  [SidebarType.MedConnectAdminAgent]: {
    name: SidebarType.MedConnectAdminAgent,
    label: 'layouts.main.sidebar.medConnectAdminAgent',
    link: '/medconnect-admin-agent',
    icon: SupportAgentIcon,
  },
  [SidebarType.EstablishmentAgenda]: {
    name: SidebarType.EstablishmentAgenda,
    label: 'layouts.main.sidebar.establishmentAgenda',
    link: '/establishment-agenda',
    icon: AgendaIcon,
  },
  [SidebarType.AdminMedicalActs]: {
    name: SidebarType.AdminMedicalActs,
    label: 'layouts.main.sidebar.adminMedicalActs',
    link: '/admin/medical-acts',
    icon: AccountBalanceIcon,
  },
  [SidebarType.AdminDesmosActs]: {
    name: SidebarType.AdminDesmosActs,
    label: 'layouts.main.sidebar.adminDesmosActs',
    link: '/admin/desmos-acts',
    icon: ReceiptLongIcon,
  },
  [SidebarType.AdminDataExport]: {
    name: SidebarType.AdminDataExport,
    label: 'layouts.main.sidebar.dataExport',
    link: '/admin/data-export',
    icon: GetAppIcon,
  },
  [SidebarType.SuperAdminDataExport]: {
    name: SidebarType.SuperAdminDataExport,
    label: 'layouts.main.sidebar.dataExport',
    link: '/super-admin/data-export',
    icon: GetAppIcon,
  },
  [SidebarType.Tutorials]: {
    name: SidebarType.Tutorials,
    label: 'layouts.main.sidebar.tutorials',
    link: '/tutorials',
    icon: OndemandVideoIcon,
  },
  [SidebarType.TimeTracking]: {
    name: SidebarType.TimeTracking,
    label: 'layouts.main.sidebar.timeTracking',
    link: '/time-tracking',
    icon: AccessTimeIcon,
  },
}
